module.exports = __webpack_public_path__ + "img/brand--supermercados-peruanos.a5f20017.png";